import { css, styled } from 'styled-components';

export const menuAccents = css`
  &.platform {
    --nav-accent: ${({ theme }) => theme.colors.blue500};
  }

  &.learn {
    --nav-accent: ${({ theme }) => theme.colors.green600};
  }

  &.pricing {
    --nav-accent: ${({ theme }) => theme.colors.pink600};
  }
`;

export const copyStyles = css`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;

  font-family: var(--font-walsheim);
  font-size: ${({ theme }) => theme.typography.fontSize.bodySm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.link};
  gap: 2px;
  line-height: ${({ theme }) => theme.typography.lineHeight.headingFive};
  min-width: 0;
`;

export const Description = styled.span`
  color: var(--nav-description-color, ${({ theme }) => theme.colors.grey600});
  font-family: var(--font-inter);
  font-size: ${({ theme }) => theme.typography.fontSize.bodyXs};
  font-weight: ${({ theme }) => theme.typography.fontWeight.body};
  line-height: ${({ theme }) => theme.typography.lineHeight.body};
  transition: color var(--nav-row-duration) var(--nav-ease);
`;
